<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text">
        {{ $t("nature-and-environment") }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            
            <tbody>
              <tr>
                <td>{{ $t("proximity-to-water-500-m") }}</td>
                <td>{{ plotItem.ENV_WAT }}</td>
              </tr>
              <tr>
                <td>{{ $t("groundwater-occurrence") }}</td>
                <td>{{ plotItem.ENV_GWA }}</td>
              </tr>
              <tr>
                <td>{{ $t("forest-areas-and-borders") }}</td>
                <td>{{ plotItem.ENV_FOR }}</td>
              </tr>
              <tr>
                <td>{{ $t("nature-reserves") }}</td>
                <td>{{ plotItem.ENV_RES }}</td>
              </tr>
              <tr>
                <td>{{ $t("water-protection") }}</td>
                <td>{{ plotItem.ENV_WAP }}</td>
              </tr>
              <tr>
                <td>{{ $t("public-infrastructure-high-voltage") }}</td>
                <td>{{ plotItem.EVN_ELE }}</td>
              </tr>
              <tr>
                <td>{{ $t("public-infrastructure-railway-network") }}</td>
                <td>{{ plotItem.EVN_TRA }}</td>
              </tr>
              <tr>
                <td>{{ $t("public-infrastructure-airport") }}</td>
                <td>{{ plotItem.EVN_AIR }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({
  components: {},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem
}
</script>

